import React, { Component, Fragment } from "react";
import "./PreLogin.scss";

//image
import single_line from "../../assets/preLoginUi/single_line.png";
import icon_1 from "../../assets/preLoginUi/icon_1.png";
import icon_2 from "../../assets/preLoginUi/icon_2.png";
import icon_3 from "../../assets/preLoginUi/icon_3.png";
import icon_4 from "../../assets/preLoginUi/icon_4.png";
import icon_5 from "../../assets/preLoginUi/icon_5.png";
import icon_6 from "../../assets/preLoginUi/icon_6.png";
import icon_7 from "../../assets/preLoginUi/icon_7.png";
import icon_8 from "../../assets/preLoginUi/icon_8.png";
import check_box from "../../assets/preLoginUi/check_box.png";
import preLogin_img_2 from "../../assets/preLoginUi/preLogin_img_2.png";
import features_1 from "../../assets/preLoginUi/features_1.png";
//commmon
import AdvisorBlog from "./AdvisorBlog";
import AdvisorSignUp from "./AdvisorSignUp";
import AdvisorSignUpModal from "./AdvisorSignUpModal";
import YourCompany from "./YourCompany";
import Contact from "./Contact";
import Button from "../../components/Button/Button";
import FooterAdvisor from "./FooterAdvisor";
// import NeedHelpAdvior from "./NeedHelpAdvisor";
import FaqCallapsibleAdvisor from "./FaqCallapsibleAdvisor";

//actions
// import { getAdvisorClientTestinomial } from "../../actions/admin";

class PreLoginAdvisorMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //testinomialList: [],
      advisorSignup: false,
    };
  }

  //   getTestinomialList = async () => {
  //     try {
  //       const res = await getAdvisorClientTestinomial();
  //       this.setState({
  //         testinomialList: res,
  //         fetching: true,
  //       });
  //     } catch (err) {
  //       console.error("getAdvisorClientTestinomial, Server err: ", err.response);
  //       const data = err.response.data;
  //       this.setState({ server_error: data.error });
  //     }
  //   };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.advisorSignup !== this.props.advisorSignup) {
      this.setState({ advisorSignup: this.props.advisorSignup });
    }
  }

  componentDidMount() {
    this.temp = setTimeout(() => {
      this.setState({ advisorSignup: true });
    }, 10000);
  }

  componentWillMount() {
    clearTimeout(this.temp);
  }

  handleTimeOut = () => {
    clearTimeout(this.temp);
  };

  render() {
    const {
      //testinomialList,
      advisorSignup,
    } = this.state;
    return (
      <Fragment>
        <div className="container-fluid">
          <div className="row justify-content-center pt-5 pb-5 bg_img_PreloginAdvisor">
            <div className="col-md-11">
              <div className="row">
                <div className="col-lg-7">
                  <div className="row mt_80 mt_mob">
                    <div className="col-12">
                      <p className="text_font_1">
                        Welcome to the Future of business Scaling
                        <img src={single_line} alt="images" className="ml-3" />
                      </p>
                      <p className="text_font_2 ft_size_mob_1 text-nowrap">Robotic Automation, </p>
                      <p className="text_font_2 ft_size_mob_1 text-nowrap">
                        {" "}
                        Advisory Alpha & Multi{" "}
                      </p>
                      <p className="text_font_2 ft_size_mob_1"> Products Unleashed </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-10">
                      <span className="text_font_3 text-nowrap">
                        Say Goodbye to Limitations for Achieving 10X Growth
                      </span>
                      <br />
                      <span className="text_font_3">
                        Your Journey to the Ultimate Platform Stops Here!
                      </span>
                    </div>
                  </div>
                  <div className="row my-4 align-items-center">
                    <div className="col-12 col-sm-10">
                      <Button
                        type="button"
                        size="lg"
                        text="Get Free Demo"
                        customClass={`col-md-5 al_btn_1 ${advisorSignup === true ? "btn" : ""}`}
                        onClick={() => this.setState({ advisorSignup: true })}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-12">
                  <div className="card al_card_5 mt_30">
                    <div className="card-body">
                      <AdvisorSignUp backPage={this.handleTimeOut} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-12" style={{ backgroundColor: "#5bb5a2" }}>
              <p className="text_font_4 mt-5 ft_size_mob_1">
                One Platform. On-Board, Advise, Execute, Track, Review, Re-Balance.
                <br />
                All things Automated.
              </p>
              <div className="row justify-content-center mt-4 mb-5">
                <div className="col-md-8 col-sm-12">
                  <span className="text_font_3">
                    Risk Profiling, Analytical Reports, Algorithmic Advice, MF Screener. Never a
                    dull moment.
                  </span>
                  <br />
                  <span className="text_font_3">
                    With FinApp, your clients can never think of another Robo Platform or a Private
                    Banker.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <YourCompany />
            </div>
          </div>
          <div className="row justify-content-center mt-5">
            <div className="col-10">
              <div className="row justify-content-between">
                <div className="col-lg-5 col-sm-12">
                  <img
                    src={features_1}
                    alt="images"
                    className=""
                    style={{ width: "100%", height: "90%" }}
                  />
                </div>
                <div className="col-lg-6 text-right">
                  <div className="d-flex flex-column">
                    <div className="flex-row align-item-enter d-md-inline-flex no-gutters">
                      <a href="">
                        <span className="text_font_1">Unique Features</span>
                        <img src={single_line} alt="images" className="ml-3" />
                      </a>
                    </div>
                    <span className="text_font_7 text-left">Features that you will see </span>
                    <span className="text_font_7 text_clr text-left">nowhere!</span>
                    <span className="text_font_3 text-left">Benefits solely for your clients</span>
                  </div>
                  <div className="row mt-3">
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-md-5 text-left">
                          <img src={icon_1} alt="images" width={"55%"} className="img_mob_width" />
                        </div>
                      </div>
                      <div className="row">
                        <p className="text_font_8">All things Digital</p>
                      </div>
                      <div className="row">
                        <p className="text_font_5 text-left">
                          Reduced cost. Increased
                          <br></br>
                          <span className="text_font_5 text-left">client Delight</span>
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-md-5 text-left">
                          <img src={icon_2} alt="images" width={"55%"} className="img_mob_width" />
                        </div>
                      </div>
                      <div className="row">
                        <p className="text_font_8">Portfolio Score</p>
                      </div>
                      <div className="row">
                        <p className="text_font_5 text-left">
                          Actual Portfolio Vs
                          <br></br>
                          <span className="text_font_5 text-left"> Ideal Portfolio Risk</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-1">
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-md-5 text-left">
                          <img src={icon_3} alt="images" width={"55%"} className="img_mob_width" />
                        </div>
                      </div>
                      <div className="row">
                        <p className="text_font_8">Model Portfolios</p>
                      </div>
                      <div className="row">
                        <p className="text_font_5 text-left">Goals & Risk based.</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-md-5 text-left">
                          <img src={icon_4} alt="images" width={"55%"} className="img_mob_width" />
                        </div>
                      </div>
                      <div className="row">
                        <p className="text_font_8 text-left">Re-Balancing Notifications</p>
                      </div>
                      <div className="row">
                        <p className="text_font_5 text-left">Never a chance of missing Goals</p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-md-5 text-left">
                          <img src={icon_5} alt="images" width={"65%"} className="img_mob_width" />
                        </div>
                      </div>
                      <div className="row">
                        <p className="text_font_8">Returns Required</p>
                      </div>
                      <div className="row">
                        {/* <div className="col-md-5"> */}
                        <p className="text_font_5 text-left">1 Godly number for Goals</p>
                        {/* </div> */}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-md-5 text-left">
                          <img src={icon_6} alt="images" width={"65%"} className="img_mob_width" />
                        </div>
                      </div>
                      <div className="row">
                        <p className="text_font_8">Attribution Analysis</p>
                      </div>
                      <div className="row">
                        <p className="text_font_5 text-left">Showcase your Advisory Alpha</p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-md-5 text-left">
                          <img src={icon_7} alt="images" width={"65%"} className="img_mob_width" />
                        </div>
                      </div>
                      <div className="row">
                        <p className="text_font_8">Dynamic Modeling</p>
                      </div>
                      <div className="row">
                        <p className="text_font_5 text-left">For your HNI clients</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-md-5 text-left">
                          <img src={icon_8} alt="images" width={"65%"} className="img_mob_width" />
                        </div>
                      </div>
                      <div className="row">
                        <p className="text_font_8">Portfolio Optimization</p>
                      </div>
                      <div className="row">
                        <p className="text_font_5 text-left">
                          Deep diagnosis with actionable insights
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center mt-5">
                <div className="col-md-3">
                  <Button
                    type="button"
                    size="lg"
                    text="Sign Up for Free"
                    customClass={`al_btn_1 ${""}`}
                    onClick={() => this.setState({ advisorSignup: true })}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center mt-5">
            <div className="col-10">
              <div className="row justify-content-between">
                <div className="col-lg-7 bg_card_clr_1">
                  <div className="row no-gutters pt-3">
                    <div className="col-sm-12">
                      <div className="d-flex flex-column">
                        <div className="flex-row align-item-enter d-md-inline-flex">
                          <a href="">
                            <span className="text_font_1">How it works</span>
                            <img src={single_line} alt="images" className="ml-3" />
                          </a>
                        </div>
                        {/* <span className="text_font_5">
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit.{" "}
                        </span>
                        <span className="text_font_5">
                          elit. Id interdum dui mollis . Suspendisse nulla :
                        </span> */}
                      </div>
                    </div>
                  </div>
                  <div className="card border-0 bg_card_clr_1 my-4">
                    <div className="card-body">
                      <div className="row">
                        <div className="col d-flex flex-row card_wrapper_7 align-self-end">
                          <span className="image_wrapper_7">
                            <img src={check_box} alt="images" className="image_dimension_3 my-2" />
                          </span>
                          <div className="d-flex flex-column my-3">
                            <span className="text_41 text_clr_8">
                              Sign up & Build your Website in seconds
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="row ">
                        <div className="col d-flex flex-row card_wrapper_7 align-self-end my-3">
                          <span className="image_wrapper_7">
                            <img src={check_box} alt="images" className="image_dimension_3" />
                          </span>
                          <div className="d-flex flex-column my-3">
                            <span className="text_41 text_clr_8">
                              Configure Robo Advisory in a few minutes
                            </span>
                            {/* <span className="text_42 text_clr_8">
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit. ...
                            </span>
                            <span>
                              <Link className="text_clr_1">read more</Link>
                            </span> */}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col d-flex flex-row card_wrapper_7 align-self-end my-2">
                          <span className="image_wrapper_7">
                            <img src={check_box} alt="images" className="image_dimension_3" />
                          </span>
                          <div className="d-flex flex-column my-3">
                            <span className="text_41 text_clr_8">
                              Set up your 1st client & upload CAS in 3 clicks
                            </span>
                            {/* <span className="text_42 text_clr_8">
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit. ...
                            </span>
                            <span>
                              <Link className="text_clr_1">read more</Link>
                            </span> */}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col d-flex flex-row card_wrapper_7 align-self-end my-2">
                          <span className="image_wrapper_7">
                            <img src={check_box} alt="images" className="image_dimension_3" />
                          </span>
                          <div className="d-flex flex-column my-2">
                            <span className="text_41 text_clr_8">
                              Scan Analytical Dashboard for Portfolio Insights
                            </span>
                            {/* <span className="text_42 text_clr_8">
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit. ...
                            </span>
                            <span>
                              <Link className="text_clr_1">read more</Link>
                            </span> */}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col d-flex flex-row card_wrapper_7 align-self-end my-2">
                          <span className="image_wrapper_7">
                            <img src={check_box} alt="images" className="image_dimension_3" />
                          </span>
                          <div className="d-flex flex-column my-2">
                            <span className="text_41 text_clr_8">
                              Portfolio Optimization for corrective actions
                            </span>
                            {/* <span className="text_42 text_clr_8">
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit. ...
                            </span>
                            <span>
                              <Link className="text_clr_1">read more</Link>
                            </span> */}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col d-flex flex-row card_wrapper_7 align-self-end my-2">
                          <span className="image_wrapper_7">
                            <img src={check_box} alt="images" className="image_dimension_3" />
                          </span>
                          <div className="d-flex flex-column my-3">
                            <span className="text_41 text_clr_8">
                              Give this experience to all clients? Upload RTA feeds.
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 mt_100">
                  <img src={preLogin_img_2} alt="images" className="" width={"90%"} />
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row justify-content-center mt-5">
            <div className="col-10">
              <div className="row no-gutters pt-3">
                <div className="col-sm-12 col-md-10">
                  <div className="d-flex flex-column">
                    <div className="flex-row align-item-enter d-md-inline-flex">
                      <a href="">
                        <span className="text_font_1">Testimonials</span>
                        <img src={single_line} alt="images" className="ml-3" />
                      </a>
                    </div>
                    <span className="text_44 my-2">What your peer</span>
                    <span className="text_44 my-2 text_clr">group is saying</span>
                  </div>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-sm-4 col-md-4 mb-3">
                  <div className="card card-radius_1" style={{ height: "105%" }}>
                    <div className="card-body">
                      <ReactStars
                        count={5}
                        size={24}
                        a11y={true}
                        value={"2"}
                        activeColor="#5bb5a2"
                      />
                      <p className="text_46 pt-2">Sunt qui esse pariatur duis deserunt mollit</p>
                      <p className="text_47">
                        Nulla Lorem mollit cupidatat irure.
                        Laborum magna nulla duis ullamco
                        cillum dolor. Voluptate exercitation
                        incididunt aliquip deserunt reprehenderit elit laborum.
                      </p>
                      <span className="text_48">Cody Fisher</span>
                      <br></br>
                      <small className="text_49">Medical Assistant</small>
                    </div>
                  </div>
                </div>
                <div className="col-sm-4 col-md-4 mb-3">
                  <div className="card card-radius_1" style={{ height: "105%" }}>
                    <div className="card-body">
                      <ReactStars
                        count={5}
                        size={24}
                        a11y={true}
                        value={"3"}
                        activeColor="#5bb5a2"
                      />
                      <p className="text_46 text_clr_8 pt-2">At lectus urna duis convallis tellus</p>
                      <p className="text_47 text_clr_8">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                        incididunt ut labore et dolore magna aliqua. Dui accumsan sit amet nulla facilisi morbi.
                        In nibh mauris cursus mattis.
                      </p>
                      <span className="text_48 text_clr_8">Jenny Wilson</span>
                      <br/>
                      <small className="text_49">Nursing Assistant</small>
                    </div>
                  </div>
                </div>
                <div className="col-sm-4 col-md-4 mb-3">
                  <div className="card card-radius_1" style={{ height: "105%" }}>
                    <div className="card-body">
                      <ReactStars
                        count={5}
                        size={24}
                        a11y={true}
                        value={"5"}
                        activeColor="#5bb5a2"
                      />
                      <p className="text_46 text_clr_8 pt-2">software programs</p>
                      <p className="text_47 text_clr_8">
                        Programs A full stack web developer is a person who can develop both client
                        and server software. In addition to mastering HTML and CSS, he/she also
                        knows how to: Program a browser.A Software Developer
                      </p>
                      <span className="text_48 text_clr_8">Mr. Amit kumar</span>
                      <br></br>
                      <small className="text_49">full stack web developer</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* youtobe */}
          {/* <div className="row justify-content-center mt-5">
            <div className="col-md-10">
              <p className="text_font_7 text-center ft_size_mob align_left_mob">
                Lorem Ipssum is a dummy Nisi cumoque in necessitabiubs
              </p>
              <p className="text_font_7 text-center ft_size_mob align_left_mob">
                That's why they love us !
              </p>
              <div className="row">
                <div className="col-md-5 mt_30">
                  <p className="text_font_11">
                    Nisi cumque in necessitatibus molestiae eaque excepturi ab. Laboriosam ipsam
                    voluptatem voluptatibus labore quam nihil. Quasi occaecatiquos ratione quia aut
                    molestiae velit et. Voluptatem id ea dicta inventore et quo
                  </p>
                  <p className="text_font_11 text-right">- Mr . John Doe</p>
                </div>
                <div className="col-md-6">
                  <img src={youtube} alt="images" className="" width={"90%"} />
                </div>
              </div>
            </div>
          </div> */}
          {/* Attain 10x scale ui */}
          <div className="row justify-content-center mt-5">
            <div className="col-md-10">
              <div className="card bg_card_clr">
                <div className="card-body">
                  <div className="row mt_100" style={{ marginBottom: "100px" }}>
                    <div className="col-md-8">
                      <p className="text_font_10 ft_size_mob">
                        Attain 10x scale <span>😍</span>
                      </p>
                      {/* <div className="row">
                        <span className="col-md-3 col-sm-6">
                          <ReactStars
                            count={5}
                            size={35}
                            a11y={false}
                            value={"4"}
                            activeColor="#F9D006"
                          />
                        </span>
                        <spam className="col-md-5 mt-3 col-sm-6">
                          <span className="h6 text-nowrap">Based on 10,000+ reviews</span>
                        </spam>
                      </div> */}
                    </div>
                    <div className="col-md-3 mt-2">
                      <Button
                        type="button"
                        size="lg"
                        text="Sign Up for Free Today!"
                        customClass={`text_clr p-3 ${advisorSignup === true ? "btn" : ""}`}
                        onClick={() => this.setState({ advisorSignup: true })}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {advisorSignup && (
            <div className="row justify-content-center">
              <AdvisorSignUpModal
                show={advisorSignup}
                onHide={() => this.setState({ advisorSignup: false })}
              />
            </div>
          )}
          {/* Need help? / FAQ'S */}
          <div className="row justify-content-center mt-5">
            <div className="col-md-10">
              <div className="d-flex flex-column">
                <span className="text_55 mb-4">FAQ'S</span>
                <FaqCallapsibleAdvisor signupModal={() => this.setState({ advisorSignup: true })} />
                {/* <NeedHelpAdvior /> */}
              </div>
            </div>
          </div>
          {/* one Platfrom ui */}
          <div className="row justify-content-center mt_100 mb-5">
            <div className="col-md-10">
              <div className="card bg_color_2">
                <div className="card-body">
                  <div className="row justify-content-left pt-5 pb-5">
                    <div className="col-md-12">
                      <p className="text_52 text-nowrap"> One Platform.</p>
                      <p className="text_52 text-nowrap">Many Benefits.</p>
                      <div className="row mt-5">
                        <div className="col-md-5 mb-3">
                          <i
                            className="fa fa-check bg_color_3 p-1 text-white rounded-circle mr-2 f_l mt-1"
                            aria-hidden="true"
                          ></i>
                          <span className="text_53 text-nowrap">
                            Scale without a Sweat, Grow Digitally
                          </span>
                        </div>
                        <div className="col mb-3">
                          <i
                            className="fa fa-check bg_color_3 p-1 text-white rounded-circle mr-2 f_l mt-1"
                            aria-hidden="true"
                          ></i>
                          <span className="text_53 text-nowrap">
                            Serves both DIY & Guided Investors
                          </span>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-5 mb-3">
                          <i
                            className="fa fa-check bg_color_3 p-1 text-white rounded-circle mr-2 f_l mt-1"
                            aria-hidden="true"
                          ></i>
                          <span className="text_53 text-nowrap">
                            Sophisticated Features, Sleek Interface
                          </span>
                        </div>
                        <div className="col mb-3">
                          <i
                            className="fa fa-check bg_color_3 p-1 text-white rounded-circle mr-2 f_l mt-1"
                            aria-hidden="true"
                          ></i>
                          <span className="text_53 text-nowrap">
                            Sales Funnel via Digital Marketing{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <AdvisorBlog />
          {/* contact ui */}
          <div className="row justify-content-center mb-5 mt-5">
            <div className="col-md-7">
              <Contact />
            </div>
          </div>
        </div>
        <div className="container-fluid bg_footer">
          <FooterAdvisor />
        </div>
      </Fragment>
    );
  }
}

export default PreLoginAdvisorMain;
